import { IntlShape } from 'react-intl';
import { messages } from './messages';
import { RoleSchema } from '@fhnw/schemas/role';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.Contacts),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['contacts'],
    },
  ],
  properties: {
    contacts: {
      title: intl.formatMessage(messages.Contacts),
      description: intl.formatMessage(messages.ContactsHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: RoleSchema({ intl, fields: ['contact', 'function'] }),
          },
        },
      },
      default: [],
    },
  },
  required: [],
});

export default Schema;
